export default {"src":"/_next/static/media/meta.7fffadf6.svg","height":41,"width":120};